import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { Colors } from "../../styles/constant";
import mobileString from "../../assets/icons/mobile-login-string.svg";
import webString from "../../assets/icons/web-login-string.svg";
import useWindowSize from "../../hooks/useWindowSize";
import { DEVICE_TYPE, tabViewPoint } from "../../utils/constants";
import threeCardsSrc from "../../assets/images/three-cards-web-4x.webp";
import threeCardsWebSrc from "../../assets/images/login-bg-image.png";
import useDeviceDetection from "../../hooks/useDeviceDetection";

interface Props {
  isWeb?: boolean;
}

const CustomOnePlatformBox: FC<Props> = ({ isWeb = false }) => {
  const { width } = useWindowSize();
  const deviceType = useDeviceDetection();
  let imgSrc = width < tabViewPoint ? mobileString : webString;
  const isMobileBrowser = deviceType === DEVICE_TYPE.ABC_WEB_MOB_CS; //true when runs on mobile browser

  const mobileHeading = "ABC Service App";
  const webHeading = "ABC Service Web";
  const subHeading = "One platform to manage all your products";

  return (
    <Box
      flexGrow={1}
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      <Box
        textAlign={isWeb ? "left" : "center"}
        display="flex"
        flexDirection="column"
        gap=".25rem"
        marginBottom="1.5rem"
      >
        {isWeb ? (
          <Box>
            <Typography
              fontSize={24}
              fontWeight={700}
              lineHeight="120%"
              color={Colors.white}
            >
              {webHeading}
            </Typography>
            <Typography variant="body1" color={Colors.white} marginTop="1rem">
              {subHeading}
            </Typography>
          </Box>
        ) : (
          <Box>
            <Typography
              fontSize={28}
              fontWeight={600}
              color={Colors.white}
              lineHeight={"2.1875rem"}
            >
              {isMobileBrowser ? webHeading : mobileHeading}
            </Typography>
            <Typography variant="body1" color={Colors.white}>
              {subHeading}
            </Typography>
          </Box>
        )}
      </Box>
      <Box
        sx={{
          backgroundImage: isWeb ? "none" : `url(${imgSrc})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
        }}
        width="100%"
        display="flex"
        justifyContent="center"
        marginTop={isWeb ? "2.75rem" : "0rem"}
      >
        <img
          src={isWeb ? threeCardsWebSrc : threeCardsSrc}
          alt="three-cards-image"
          style={{ width: "100%", maxWidth: "311px", margin: "0 1.5rem" }}
        />
      </Box>
    </Box>
  );
};

export default CustomOnePlatformBox;
